import React, {Fragment} from "react";
import imageKozijn from '../../../images/situation/maten/kozijn/D.jpg';
import imageMuur from '../../../images/situation/maten/muur/D.jpg';
import PropTypes from "prop-types";
import imageMuurKlamp from "../../../images/situation/maten/muur/Ynietzichtbaar.jpg";
import imageKozijnKlamp from "../../../images/situation/maten/kozijn/Ynietzichtbaar.jpg";
import imageMuurKlampVisible from "../../../images/situation/maten/muur/Yzichtbaar.jpg";
import imageKozijnKlampVisible from "../../../images/situation/maten/kozijn/Yzichtbaar.jpg";


export default function MaatD(props) {
    let image;
    if (props.isMuurMontage) {
        switch (props.klampen) {
            case "visible":
                image = imageMuurKlampVisible;
                break;
            case "invisible":
                image = imageMuurKlamp;
                break;
            default:
                image = imageMuur;
                break;
        }
    } else {
        switch (props.klampen) {
            case "visible":
                image = imageKozijnKlampVisible;
                break;
            case "invisible":
                image = imageKozijnKlamp;
                break;
            default:
                image = imageKozijn;
                break;
        }
    }
    return <Fragment>
        <div className="addtextMore">
            Vul hier de dikte van het luik in, in milimeters.
            {props.klampen === 'visible' || props.klampen === 'invisible' ?
                <>Deze maat is <b>exclusief</b> klampdikte.<br/></> : null}
        </div>
        <img className="explainImage" src={image} alt=""/>
    </Fragment>;
}

MaatD.propTypes = {
    isMuurMontage: PropTypes.bool.isRequired,
    klampen: PropTypes.oneOf("none", "visible", "invisible").isRequired,
}